import type { MouseEvent } from 'react';
import styled, { css } from 'styled-components';

import { Flex, VFlex } from '@/components/base';
import Tooltip from '@/components/Tooltip/TooltipV2';
import Typo from '@/components/Typography/Typo';
import { COMPANY_UNKNOWN, CUSTOMER_ANONYMOUS } from '@/configs/reserved-word';
import { DATE_FORMAT, getTimezoneDayjs } from '@/utils/time';

const BlockItem = (props: {
  date: string;
  company?: string;
  customer?: string;
  title: string;
  selected?: boolean;
  onClick: (e: MouseEvent) => void;
}) => {
  const { date, company, customer, title, selected, onClick } = props;
  return (
    <BlockStyle onClick={onClick} j="space-between" selected={selected}>
      <Typo type="body2" weight="m" multilineEllipsis={3}>
        "{title}"
      </Typo>
      <Flex g={12} a="center">
        <Flex g={12} a="center">
          <Typo type="body3" className="text-gray-600">
            {getTimezoneDayjs(date).format(DATE_FORMAT.readable)}
          </Typo>
          <Tooltip tooltipNode={company || COMPANY_UNKNOWN}>
            <Typo
              type="body3"
              className="text-gray-600"
              style={{ maxWidth: 150 }}
              multilineEllipsis={1}
            >
              {company || COMPANY_UNKNOWN}
            </Typo>
          </Tooltip>
          <Tooltip tooltipNode={customer || CUSTOMER_ANONYMOUS}>
            <Typo
              type="body3"
              className="text-gray-600"
              style={{ maxWidth: 150 }}
              multilineEllipsis={1}
            >
              {customer || CUSTOMER_ANONYMOUS}
            </Typo>
          </Tooltip>
        </Flex>
      </Flex>
    </BlockStyle>
  );
};

const BlockStyle = styled(VFlex)<{ selected?: boolean }>`
  padding: 8px 12px;
  background-color: ${(props) => props.theme.colors.gray100};
  border-radius: ${(props) => props.theme.radius.card}px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all 0.2s;
  gap: 4px;
  &:hover {
    background-color: ${(props) => props.theme.colors.gray200};
  }
  ${({ selected }) =>
    selected &&
    css`
      background-color: ${(props) => props.theme.colors.gray200};
      border-color: ${(props) => props.theme.colors.primary100};
    `}
`;

export default BlockItem;
